export default "__VITE_ASSET__BSXbd4ec__"